import { $t } from '../../i18n'
import { ApplicationAPIError } from './ApplicationAPIError'

export class ApplicationValidationAPIError extends ApplicationAPIError {
  public readonly validationErrors: string[]

  constructor(validationErrors: string[], options?: ErrorOptions) {
    super($t('Request has failed with validation errors'), options)
    this.validationErrors = validationErrors
  }
}
